{
  "profilePage": {
    "editProfile": "Редактировать профиль",
    "createProfile": "Создать профиль",
    "changePassword": "Изменить пароль",
    "changeLanguage": "Изменить язык",
    "changeInfo": "Редактировать",
    "personalInfo": "Личные данные",
    "userAttributes": "Атрибуты пользователя",
    "userPreferences": "Настройки пользователя",
    "loadError": "Ошибка загрузки данных",
    "loadErrorDescription": "Не удалось загрузить данные профиля. Сервер может быть временно недоступен. Попробуйте повторить запрос.",
    "avatar": {
      "uploading": "Загрузка",
      "selectImage": "Выбрать изображение",
      "mimeTypeError": "Изображение должно быть формата JPG или PNG!",
      "fileSizeError": "Размер изображения должен быть менее 2MB!"
    }
  },
  "passwordDialog": {
    "title": "Смена пароля",
    "oldPassword": "Текущий пароль",
    "newPassword": "Новый пароль",
    "rePassword": "Повторите новый пароль"
  },
  "languageDialog": {
    "title": "Выберите язык"
  },
  "avatarDialog": {
    "title": "Фото профиля"
  },
  "userDialog": {
    "title": "Пользователь"
  },
  "userList": {
    "title": "Реестр пользователей"
  },
  "userTokens": {
    "modalTitle": "Управление токенами",
    "columns": {
      "name": "Системное имя",
      "display_name": "Название",
      "description": "Описание",
      "status": "Статус",
      "last_used_at": "Использован",
      "active": "Активен",
      "inactive": "Неактивен",
      "never": "Никогда",
      "deactivateTitle": "Вы действительно хотите деактивировать токен?"
    },
    "deactivate": "Деактивировать",
    "createToken": "Создать токен",
    "createModal": {
      "title": "Новый токен для",
      "token": "Токен",
      "label": "Название",
      "name": "Системное имя",
      "description": "Описание",
      "generate": "Сгенерировать",
      "alert": "Внимание: Сохраните этот токен в безопасном месте. Мы не храним его в открытом виде и не покажем снова."
    }
  },
  "userItem": {
    "profile": "Профиль",
    "surname": "Фамилия",
    "name": "Имя",
    "ldap_id": "LDAP",
    "is_password_expired": "Пароль просрочен",
    "correct": "Да",
    "incorrect": "Нет",
    "patronymic": "Отчество",
    "email": "E-mail",
    "login": "Логин",
    "language": "Язык",
    "password": "Пароль",
    "confirmPassword": "Повторите пароль",
    "status": "Статус",
    "connected_idps": "Провайдеры IDP",
    "connected_ldaps": "Каталоги LDAP",
    "api_token": "API токен",
    "statuses": {
      "title": "Статус",
      "active": "Активен",
      "block": "Заблокирован",
      "none": "Не установлен"
    },
    "sessions_max_count": "Максимальное количество сессий",
    "password_updated_at": "Дата обновления пароля",
    "password_expired_at": "Дата окончания срока действия пароля",
    "login_failed_count": "Число неуспешных попыток входа в систему",
    "login_failed_at": "Дата последней неуспешной попытки входа в систему",
    "last_action_at": "Дата последней удачной пользовательской сессии",
    "updated_at": "Дата обновления пользователя в базе данных",
    "created_at": "Дата создания пользователя в базе даных",
    "addAttributes": "Добавить атрибуты",
    "editProfile": "Редактировать профиль",
    "createProfile": "Создать профиль",
    "writePassword": "Введите пароль",
    "confirmDelete": "Вы действительно хотите удалить пользователя?",
    "confirmBlock": "Вы действительно хотите заблокировать пользователя?"
  },
  "UserAvatar": {
    "newAvatar": "Новое фото загружено",
    "deleteAvatar": "Фото удалено"
  },
  "sessionList": {
    "title": "Пользовательские сессии",
    "terminateSession": "Завершить сессию пользователя"
  },
  "sessionItem": {
    "login": "Логин",
    "last_action_at": "Последнее действие",
    "expired_at": "Сессия устареет",
    "addr": "Адрес",
    "agent": "Клиент"
  }
}